import { useEffect, useState } from 'react'
import { StyleSheet, View, ViewProps } from 'react-native'
import { useFloor, useStore } from 'zens-store'
import { shortLocalizedDate, shortLocalizedTime, BrandingIdentity, Color, Font, Text } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  column: {
    flex: 1,
  },
  title: {
    fontFamily: Font.light,
    letterSpacing: 4,
  },
  time: {
    alignItems: 'flex-end',
  },
  date: {
    color: Color.metalGrey,
    letterSpacing: 2,
  },
})

interface Props extends ViewProps {
  companyId: number
  floorId: number
}

const InsightsLiveKioskHead = (props: Props) => {
  const { companyId, floorId, style, ...otherProps } = props
  const { i18n } = useStore()
  const floor = useFloor({ companyId, floorId })

  const currentTime = () => {
    return shortLocalizedTime(new Date(), i18n.language)
  }
  const currentDate = () => {
    return shortLocalizedDate(new Date(), i18n.language)
  }
  const [time, setTime] = useState(currentTime())
  const [date, setDate] = useState(currentDate())

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(currentTime())
      setDate(currentDate())
    }, 60000)
    return () => clearInterval(interval)
  }, [])

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <Text level={1} style={[styles.title, styles.column]}>
        {floor.data?.displayName}
      </Text>
      <BrandingIdentity style={styles.column} size="L" />
      <View style={[styles.time, styles.column]}>
        <Text level={1} style={[styles.title, styles.column]}>
          {time}
        </Text>
        <Text style={styles.date}>{date}</Text>
      </View>
    </View>
  )
}

export default InsightsLiveKioskHead
